import { css } from 'aphrodite';
import { parseAsString, useQueryState } from 'nuqs';
import { NavLink } from 'react-router-dom';
import { useGetBoard } from '../../../../queries';
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '../../../components/Breadcrumb';
import { MultiContainerHeader } from '../../../components/MultiContainerHeader';
import { TabContent, TabList, TabRoot, TabTrigger } from '../../../components/Tabs';
import { Page } from '../../../components-v2/PageLayout';
import { ROUTES } from '../../../constants/routes';
import { baseStyleSheet } from '../../../styles/styles';
import { styleSheet as advancedReportingStyleSheet } from '../styles';
import { DetailsTab } from './components/DetailsTab';
import { OverviewTab } from './components/OverviewTab';

export const OpportunitiesAdvancedReporting = () => {
	const [boardId] = useQueryState('boardId', parseAsString);

	const getBoardQuery = useGetBoard({ boardId: boardId ?? '' });
	const selectedBoardName = getBoardQuery.data?.name;

	return (
		<Page>
			<div className={css(advancedReportingStyleSheet.pageContainer)}>
				<MultiContainerHeader
					appBarHeader={
						<Breadcrumb>
							<BreadcrumbList>
								<BreadcrumbItem>
									<BreadcrumbLink asChild>
										<NavLink to={ROUTES.dataBoards.home}>
											<h1 className={css(baseStyleSheet.breadcrumbTitle)}>Data Boards</h1>
										</NavLink>
									</BreadcrumbLink>
								</BreadcrumbItem>
								{boardId ? (
									<>
										<BreadcrumbSeparator />
										<BreadcrumbItem>
											<BreadcrumbLink asChild>
												<NavLink to={`/dataBoards/opportunities/${boardId}`}>
													<h1 className={css(baseStyleSheet.breadcrumbTitle)}>
														{selectedBoardName ?? 'Opportunities'}
													</h1>
												</NavLink>
											</BreadcrumbLink>
										</BreadcrumbItem>
									</>
								) : null}
								<BreadcrumbSeparator />
								<BreadcrumbItem>
									<BreadcrumbPage>Advanced Reporting</BreadcrumbPage>
								</BreadcrumbItem>
							</BreadcrumbList>
						</Breadcrumb>
					}
				/>

				<TabRoot defaultValue='overview'>
					<TabList>
						<TabTrigger value='overview'>Overview</TabTrigger>
						<TabTrigger value='details'>Details</TabTrigger>
					</TabList>

					<TabContent value='overview'>
						<OverviewTab boardId={boardId} />
					</TabContent>

					<TabContent value='details'>
						<DetailsTab boardId={boardId} />
					</TabContent>
				</TabRoot>
			</div>
		</Page>
	);
};
